var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-navigation"},[_c('hr'),_vm._l((_vm.searchResult),function(node,i){return _c('ListCard',{key:i,attrs:{"title":node.title},nativeOn:{"click":function($event){return _vm.selectNode(node)}}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }